module.exports = __webpack_public_path__ + "static/media/storepreviewStoreFive.d2136a88.svg";